import { ref } from 'vue'
import { defineStore } from 'pinia'

import {
  sendRequest,
  resetRequestStatus,
  convertApiDataFromStore,
} from '@services/api/requestStoreUtils'

import {
  type SendRequestConfig,
  type EndpointConfig,
  type ResetRequestStatusConfig,
} from '@services/api/declarations'

import {
  type UserStoreShape,
} from '@services/User/declarations'

export const useApiUserStore = defineStore('apiUser', () => {
  const store = useApiUserStore()

  // ***
  // STATE
  // ***
  const getUserProfile = ref<UserStoreShape['getUserProfile']>()
  const getUserByUsername = ref<UserStoreShape['getUserByUsername']>()
  const patchUserChangePassword = ref<UserStoreShape['patchUserChangePassword']>()
  const postUserPasswordResetConfirm = ref<UserStoreShape['postUserPasswordResetConfirm']>()
  const postUserPasswordResetRequest = ref<UserStoreShape['postUserPasswordResetRequest']>()
  const postUserPasswordResetValidate = ref<UserStoreShape['postUserPasswordResetValidate']>()
  const getOrphanedManagers = ref<UserStoreShape['getOrphanedManagers']>()
  return {
    // State
    getUserProfile,
    getUserByUsername,
    patchUserChangePassword,
    postUserPasswordResetConfirm,
    postUserPasswordResetRequest,
    postUserPasswordResetValidate,
    getOrphanedManagers,
    // Actions
    sendRequest: <Config>(
      config: SendRequestConfig<Config>,
    ): ReturnType<typeof sendRequest> => sendRequest(store, config),
    resetRequestStatus: (
      storeKey: ResetRequestStatusConfig['storeKey'],
      kind: ResetRequestStatusConfig['kind'],
    ): ReturnType<typeof resetRequestStatus> => resetRequestStatus(store, storeKey, kind),
    convertApiDataFromStore: (
      storeKey: EndpointConfig['storeKey'],
      result: Record<string, unknown>,
    ): ReturnType<typeof convertApiDataFromStore> => convertApiDataFromStore(store, storeKey, result),
  }
})
